import { getSpecificAppConfig } from 'aster-foundation/core/astercore/appConfig/redux/actions';
import { postMyPrescriptionDetails } from 'aster-foundation/core/teleconsultant/records/redux/actions';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IMG_THANKS, IMG_USER } from '../../Assets/images';
import {
  NAME_FORMAT,
  UAE_CODE_DEFAULT,
  convertStringtoTitleCase,
  errorHandling,
  validateEmail,
  MESSAGE_FORMAT,
} from '@common/Utility/common-utils';
import { ButtonBase, InputFieldControl, MobileInputFieldControl } from '../Forms';
import SelectControl from '../Forms/Select/Select';
import RightSideBar from '../RightSideBar/RightSideBar'; 
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const ContactFormSidebar = (props) => {
  const dispatch = useDispatch();
  const [isGuestUser, setIsGuestuser] = useState(false);
  const [isLoggedInUser, setIsLoggedInUser] = useState(false);
  const [TopicsList, setTopicsList] = React.useState([]);
  const [guesttopic, setGuesttopic] = useState('Select topic');
  const [topic, setTopic] = useState('Select topic');
  const [service, setService] = useState('Select service');
  const [message, setMessage] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [extValue, setExtValue] = useState(UAE_CODE_DEFAULT);
  const [mobnumber, setMobNumber] = useState('');
  const [successModal, setSuccessModal] = React.useState(false);
  const [serviceData, setServiceData] = useState([]);

  const [errors, setErrors] = useState({});
  const router = useRouter();
  const generateURL = useNavigationURL();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const textareaRef = useRef();

  const maxChars = 280;
  const remainingChars = maxChars - message.length;

  const updateTextareaHeight = () => {
    if (textareaRef.current) {
      const { scrollHeight } = textareaRef.current;
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${scrollHeight}px`;
      textareaRef.current.style.marginTop = '0';
    }
  };

  const getServiceDataList = (list) => {
    const arr = [];
    if (list) {
      list.forEach((element) => {
        arr.push({
          text: element,
          value: element,
        });
      });
    }
    return arr;
  };

  const getServiceList = (list) => {
    const arr = [];
    if (list) {
      list.forEach((element) => {
        arr.push({
          text: element?.type,
          value: element?.id,
          topicName: element?.value?.split(','),
        });
      });
    }
    return arr;
  };

  const handleClick = () => {
    if (userLogin) {
      setIsLoggedInUser(true);
    } else {
      setIsGuestuser(true);
    }
    const queryParam = { name: 'supportServiceTopic' };
    dispatch(
      getSpecificAppConfig({
        queryParam,
        onSuccess: (response) => {
          setServiceData(getServiceList(response?.data));
        },
        onFailure: (err) => {
          errorHandling(err, true);
        },
      }),
    );
  };

  useEffect(() => {
    handleClick();
  }, []);

  const resetForm = () => {
    if (userLogin) {
      setTopic('Select topic');
      setService('Select service');
      setMessage('');
    } else {
      setMessage('');
      setGuesttopic('Select topic');
      setService('Select service');
      setFirstName('');
      setEmail('');
      setExtValue(UAE_CODE_DEFAULT);
      setMobNumber('');
    }
  };

  const findFormErrors = () => {
    const newErrors = {};
    if (userLogin) {
      if (!topic || (topic === 'Select topic' && service !== 'Select service')) newErrors.topic = 'Please select topic';
      if (!service || service === 'Select service') newErrors.service = 'Please select service';
      if (!message || !/\S/.test(message)) newErrors.message = 'Please enter message';
      else if (message.length > 280) newErrors.message = 'Do not enter more than 280 characters';
      else if (MESSAGE_FORMAT.test(message)) newErrors.message = 'Multiple spaces are not allowed';
    } else {
      if (!service || service === 'Select service') newErrors.service = 'Please select service';
      if (!firstName || firstName === '') newErrors.firstName = 'Please enter first name';
      else if (NAME_FORMAT.test(firstName)) newErrors.firstName = 'Name cannot contain special characters';
      if (!guesttopic || (guesttopic === 'Select topic' && service !== 'Select service'))
        newErrors.guesttopic = 'Please select topic';
      if (!email || email === '') newErrors.email = 'Please enter email';
      else if (!validateEmail(email)) newErrors.email = 'Please enter valid email';
      if (!mobnumber || mobnumber === '') newErrors.mobnumber = 'Please enter mobile number';
      else if (extValue === '+971') {
        if (mobnumber.length !== 9) newErrors.mobnumber = 'Please enter valid mobile number1.0';
      } else if (mobnumber.length !== 10) newErrors.mobnumber = 'Please enter valid mobile number2.0';
      if (!message || !/\S/.test(message)) newErrors.message = 'Please enter message';
      else if (message.length > 280) newErrors.message = 'Do not enter more than 280 characters';
      else if (MESSAGE_FORMAT.test(message)) newErrors.message = 'Multiple spaces are not allowed';
    }
    return newErrors;
  };

  const primaryButtonClicked = () => {
    let params;
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      if (userLogin) {
        params = {
          templateType: 'default_request',
          hisSystemName: userLogin.extension.find((item) => item.url === 'hisSystem')?.valueIdentifier?.system,
          description: `Name :${userLogin?.name?.[0]?.text} Message : ${message}`,
          hisSystemId: userLogin?.extension.find((item) => item.url === 'hisSystem')?.valueIdentifier?.value,
          userType: 'Patient',
          userId: userLogin?.id,
          subject: `VCP Support Request - ${topic}`,
          serviceType: service,
        };
      } else {
        params = {
          templateType: 'default_request',
          description: `Name:${firstName} Email:${email} Mobile Number:${extValue}-${mobnumber} Message: ${message}`,
          subject: `VCP Support Request - ${guesttopic}`,
          serviceType: service,
        };
      }
      const requestParams = params;
      dispatch(
        postMyPrescriptionDetails({
          requestParams,
          onSuccess: () => {
            setIsGuestuser(false);
            setIsLoggedInUser(false);
            setErrors({});
            setSuccessModal(true);
          },
          onFailure: (err) => {
            errorHandling(err, true);
          },
        }),
      );
    }
  };

  const navigateToHome = () => {
    if (router.pathname === '/') {
      setSuccessModal(false);
    } else {
      router.push({ pathname: generateURL(`/`) });
    }
  };

  return (
    <RightSideBar
      modalTitle="Contact Us"
      size="md"
      footerAlignment="center"
      primaryButtonText={successModal ? '' : 'Submit'}
      bodyBg
      footerBtnFullWidth
      closeButton
      customClass="faq-contact-wrapper with-btn"
      footerEnable={!successModal}
      handleClose={() => {
        setErrors({});
        resetForm();
        setIsLoggedInUser(false);
        setIsGuestuser(false);
        setSuccessModal(false);
        props?.setShowContactSideBar(false);
      }}
      primaryButtonClicked={primaryButtonClicked}
    >
      {isLoggedInUser && (
        <div className="form-wrapper">
          <div className="header faq-border">
            {!userLogin?.extension?.find((item) => item.url === 'nameInitials')?.valueString ? (
              <div
                className="member-image mb-3 text-center"
                style={{
                  backgroundImage: userLogin?.photo?.[0]?.url
                    ? `url(${userLogin?.photo?.[0]?.url})`
                    : `url(${IMG_USER.src})`,
                }}
              />
            ) : (
              <div className="member-image mb-3 text-center avtarName">
                {userLogin?.extension?.find((item) => item.url === 'nameInitials')?.valueString}
              </div>
            )}
            <div className="user-info">
              <p className="name text-capitalize">{convertStringtoTitleCase(userLogin?.name?.[0]?.text)}</p>
              <p className="mail">{userLogin?.telecom?.find((item) => item?.system === 'email')?.value}</p>
            </div>
          </div>
          <div className="contact-form-wrapper contact-error-text">
            <Row>
              <Col lg={12} className="mb-4">
                <SelectControl
                  enableFullWidth
                  data={serviceData}
                  caption={service === 'Select service' ? 'Service' : service}
                  label={service === 'Select service' ? '' : 'Service'}
                  // data-test="div"
                  onChange={(e) => {
                    setService(e?.target?.value);
                    setTopic('Select topic');
                    if (service) setErrors({ ...errors, service: null });
                    if (serviceData.map((x) => x?.text === e?.target?.value)) {
                      setTopicsList(
                        getServiceDataList(serviceData?.find((x) => x?.text === e?.target?.value)?.topicName),
                      );
                    }
                  }}
                  isLabel="true"
                  isInvalid={!!errors.service}
                  errorMessage={errors.service}
                  customClass={service === 'Select service' ? 'select-placeholder' : ''}
                />
              </Col>
              <Col lg={12} className="mb-4">
                <SelectControl
                  enableFullWidth
                  data={TopicsList}
                  disabled={service === 'Select service'}
                  caption={topic === 'Select topic' ? 'Topic' : topic}
                  label={topic === 'Select topic' ? '' : 'Topic'}
                  data-test="div"
                  onChange={(e) => {
                    setTopic(e.target.value);
                    if (topic) setErrors({ ...errors, topic: null });
                  }}
                  isLabel="true"
                  isInvalid={!!errors.topic}
                  errorMessage={errors.topic}
                  customClass={topic === 'Select topic' ? 'select-placeholder' : ''}
                />
              </Col>
              <Col lg={12}>
                <InputFieldControl
                  label="Message"
                  as="textarea"
                  placeholder=""
                  data-test="div1"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    updateTextareaHeight();
                    if (message) setErrors({ ...errors, message: null });
                  }}
                  refTest={textareaRef}
                  readOnly={false}
                  name="message"
                  valueType={message}
                  isInvalid={!!errors.message}
                  errorMessage={errors.message}
                  maxLength={maxChars}
                  isLabel
                  rows="7"
                  isTextArea
                  onClick={() => updateTextareaHeight()}
                />
                <div className="text_remain_count">{remainingChars} characters remaining</div>
              </Col>
            </Row>
          </div>
        </div>
      )}
      {isGuestUser && (
        <div className="form-wrapper">
          <div className="contact-form-wrapper">
            <Row>
              <Col lg={12} className="mb-4">
                <InputFieldControl
                  label="First Name"
                  type="text"
                  placeholder="Enter First Name"
                  data-test="id1"
                  onChange={(e) => {
                    setFirstName(e.target.value.replace(/[0-9]/g, ''));
                    if (firstName) setErrors({ ...errors, firstName: null });
                  }}
                  name="firstName"
                  valueType={firstName}
                  isInvalid={!!errors.firstName}
                  errorMessage={errors.firstName}
                  isLabel
                />
              </Col>
              <Col lg={12} className="mb-4">
                <InputFieldControl
                  label="Email Address"
                  type="email"
                  placeholder="Enter Email"
                  data-test="id2"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (email) setErrors({ ...errors, email: null });
                  }}
                  name="email"
                  valueType={email}
                  isInvalid={!!errors.email}
                  errorMessage={errors.email}
                  isLabel
                />
              </Col>
              <Col md={12} className="mb-4">
                <MobileInputFieldControl
                  label="Mobile Number"
                  extValue={extValue}
                  valueType={mobnumber}
                  readOnly=""
                  textType="string"
                  placeholder="Mobile Number"
                  data-test="id3"
                  handleSelect={(e) => {
                    setExtValue(e);
                    if (e === '+971') {
                      if (mobnumber.length >= 10) {
                        setMobNumber(mobnumber.slice(0, 9));
                      }
                    }
                  }}
                  onChange={(e) => {
                    if (extValue === '+971') {
                      if (e.target.value.length < 10) {
                        setMobNumber(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, ''));
                      }
                    } else if (e.target.value.length < 11) {
                      setMobNumber(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, ''));
                    }
                    if (mobnumber) setErrors({ ...errors, mobnumber: null });
                  }}
                  isInvalid={!!errors.mobnumber}
                  errorMessage={errors.mobnumber}
                />
              </Col>
              <Col lg={12} className="mb-4">
                <SelectControl
                  enableFullWidth
                  data={serviceData}
                  caption={service === 'Select service' ? 'Service' : service}
                  label={service === 'Select service' ? '' : 'Service'}
                  data-test="div"
                  onChange={(e) => {
                    setService(e?.target?.value);
                    setGuesttopic('Select topic');
                    if (service) setErrors({ ...errors, service: null });
                    if (serviceData.map((x) => x?.text === e?.target?.value)) {
                      setTopicsList(
                        getServiceDataList(serviceData.find((x) => x?.text === e?.target?.value)?.topicName),
                      );
                    }
                  }}
                  isLabel="true"
                  isInvalid={!!errors.service}
                  errorMessage={errors.service}
                  customClass={service === 'Select service' ? 'select-placeholder' : ''}
                />
              </Col>
              <Col lg={12} className="mb-4">
                <SelectControl
                  enableFullWidth
                  data={TopicsList}
                  disabled={service === 'Select service'}
                  caption={guesttopic === 'Select topic' ? 'Topic' : guesttopic}
                  label={guesttopic === 'Select topic' ? '' : 'Topic'}
                  data-test="id4"
                  onChange={(e) => {
                    setGuesttopic(e.target.value);
                    if (guesttopic) setErrors({ ...errors, guesttopic: null });
                  }}
                  isLabel="true"
                  isInvalid={!!errors.guesttopic}
                  errorMessage={errors.guesttopic}
                  customClass={guesttopic === 'Select topic' ? 'select-placeholder' : ''}
                />
              </Col>
              <Col lg={12}>
                <InputFieldControl
                  label="Message"
                  as="textarea"
                  placeholder=""
                  data-test="div1"
                  onChange={(e) => {
                    setMessage(e.target.value);
                    updateTextareaHeight();
                    if (message) setErrors({ ...errors, message: null });
                  }}
                  refTest={textareaRef}
                  readOnly={false}
                  name="message"
                  valueType={message}
                  isInvalid={!!errors.message}
                  errorMessage={errors.message}
                  maxLength={maxChars}
                  isLabel
                  rows="7"
                  isTextArea
                  onClick={updateTextareaHeight()}
                />
                <div className="text_remain_count">{remainingChars} characters remaining</div>
              </Col>
            </Row>
          </div>
        </div>
      )}
      {successModal && (
        <div className="form-wrapper">
          <div className="contact-form-wrapper">
            <Row>
              <Col lg="12">
                <div className="thanks-wrapper">
                  <div className="tanks-img">
                    <Image src={IMG_THANKS.src} width={123} height={133} alt="" className="me-1" />
                  </div>
                  <p className="name-thanks mt-4">
                    {userLogin
                      ? `Thanks ${convertStringtoTitleCase(userLogin?.name?.[0]?.given?.[0])}!`
                      : `Thanks ${convertStringtoTitleCase(firstName)}!`}
                  </p>
                  <p className="thanks-detail">
                    We have taken your request successfully, our team will get back to you in 48 hours.
                  </p>
                  <div className="text-center mt-3">
                    <ButtonBase
                      data-test="button"
                      minWidth="321px"
                      text="Go to home"
                      variant="primary"
                      customClass="ok-btn"
                      onClick={navigateToHome}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </RightSideBar>
  );
};
ContactFormSidebar.propTypes = {
  setShowContactSideBar: PropTypes.func,
};
ContactFormSidebar.defaultProps = {
  setShowContactSideBar: () => {},
};
export default ContactFormSidebar;
